import React, { useRef, useState } from "react";
import SearchSubmitProps from "./search-submit.props";
import FaIcon from "../fa-icon/fa-icon";
import IconEnum from "../../enums/icon.enum";
import SizeEnum from "../../enums/size.enum";
import IconLibraryEnum from "../../enums/icon-library.enum";
import "./search-submit.scss";

const SearchSubmit = (props: SearchSubmitProps) => {
  const {
    className = "",
    name = "search",
    placeHolder = "Search",
    minLength,
    maxLength,
    inputLength = 25,
    onChange,
    onSearch,
    onClear
  } = props;
  const [showClearResults, setShowClearResults] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchRef = useRef(null);

  const handleClear = () => {
    onClear(showClearResults);
    setShowClearResults(false);
    searchRef.current.value = "";
    setSearchText("");
  };

  const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    onSearch();
    setShowClearResults(searchText.length > 0);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
    onChange(event);
  };

  return (
    <div id="search-submit" data-testid="search-submit" className={`search-submit ${className}`}>
      <input
        name={name}
        placeholder={showClearResults ? "" : placeHolder}
        minLength={minLength}
        maxLength={maxLength}
        size={inputLength}
        onChange={(event) => handleChange(event)}
        onKeyUp={(event) => handleEnter(event)}
        ref={searchRef}
      />
      <div className="search-submit-buttons">
        {(showClearResults || searchText) && (
          <button data-testid="clear-text-btn" className="clear-button" onClick={() => handleClear()}>
            {showClearResults && <div className="clear-button-text"> Clear Results </div>}
            {searchText && !showClearResults && (
              <FaIcon icon={IconEnum.XMARK} library={IconLibraryEnum.REGULAR} size={SizeEnum.MEDIUM} />
            )}
          </button>
        )}
        <button data-testid="search-text-btn" className="search-button" onClick={() => handleSearch()}>
          <FaIcon icon={IconEnum.MAGNIFYING_GLASS} library={IconLibraryEnum.SOLID} size={SizeEnum.MEDIUM} />
        </button>
      </div>
    </div>
  );
};

export default SearchSubmit;
